import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {environment} from 'environment';
import {TargetGroupAnalytics} from '../models/target-group-analytics.model';

@Injectable()
export class TargetGroupAnalyticsRepository {

  constructor(private http: Http) {}

  public getAnalytics(from: string, to: string, targetGroupIds: Array<string>): Observable<TargetGroupAnalytics> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true
    });

    const targetGroupsParam = encodeURIComponent(JSON.stringify(targetGroupIds));
    const url = `${environment.targetgroupsExport}?from=${from}&to=${to}&targetGroups=${targetGroupsParam}`;

    return this.http.get(url, options)
      .map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/repositories/target-group-analytics.repository.ts